import { MainAwardItem } from './AwardItem';
export const MainAwards = () => {
  return <div className="grid grid-cols-1 items-center justify-items-stretch gap-[46px] mobile-lg:grid-cols-2 mobile-lg:gap-x-sm mobile-lg:gap-y-[46px] tablet-sm:grid-cols-3 tablet-sm:justify-items-center tablet-sm:gap-xl" data-sentry-component="MainAwards" data-sentry-source-file="MainAwards.tsx">
      <MainAwardItem title="대상" subTitle="(교육부 장관상)" description={<span>
            2025 K-에듀테크 콘테스트
            <br />
            교수·학습 혁신 분야
          </span>} iconPath="/assets/award/award_icon_1.webp" className="mobile-lg:col-span-2 tablet-sm:order-2 tablet-sm:col-span-1" data-sentry-element="MainAwardItem" data-sentry-source-file="MainAwards.tsx" />
      <MainAwardItem title="에듀테크 대상" titleClassName="text-yellow-900" description={<span>
            2025 대한민국 리딩기업대상
            <br />
            스타트업 대상 AI 에듀테크 부문
          </span>} iconPath="/assets/award/award_icon_2.webp" className="bg-yellow-50 tablet-sm:order-1" data-sentry-element="MainAwardItem" data-sentry-source-file="MainAwards.tsx" />
      <MainAwardItem title="최고 혁신상" titleClassName="text-yellow-900" description={<span>
            AES Korea Awards
            <br />
            Best Innovation Prize
          </span>} iconPath="/assets/award/award_icon_2.webp" className="bg-yellow-50 tablet-sm:order-3" data-sentry-element="MainAwardItem" data-sentry-source-file="MainAwards.tsx" />
    </div>;
};